module.exports = {"TXTCLI_I_do_not_wish_to_receive_e_mai_ELL":{"id":"TXTCLI_I_do_not_wish_to_receive_e_mai_ELL","defaultMessage":"このポーカークラブからのメールを受信しない"}}